module.exports = __webpack_public_path__ + "img/1left-513db81c.png";